import { useEffect, useRef } from "react";

/**
 * 자동 플레이 타이머 훅.
 * enabled 상태에서 5초마다 onTick을 호출하며, isFlipped 상태를 전달.
 * isFlipped/currentIndex/wordsLength가 변경되면 타이머가 리셋됨.
 */
export function useAutoPlay(
  enabled: boolean,
  isFlipped: boolean,
  currentIndex: number,
  wordsLength: number,
  onTick: (isFlipped: boolean) => void,
): void {
  const onTickRef = useRef(onTick);

  useEffect(() => {
    onTickRef.current = onTick;
  }, [onTick]);

  useEffect(() => {
    if (!enabled || currentIndex >= wordsLength) {
      return;
    }

    const timer = setTimeout(() => {
      onTickRef.current(isFlipped);
    }, 5000);

    return () => clearTimeout(timer);
  }, [enabled, isFlipped, currentIndex, wordsLength]);
}
